/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 16/10/23
 */

import { INavigateProvider, NavigateContext } from '@/components/contexts/NaviateContext/NavigateProvider';
import { useContext } from 'react';

function useNavigateOptions(): INavigateProvider {
    return useContext(NavigateContext);
}

export default useNavigateOptions;
